export class MailService {
  private apiUrl: string = process.env.VUE_APP_API_URL as string;

  public async subscribe(email: string, name?: string): Promise<Response> {
    return await fetch(`${this.apiUrl}/app/subscribe`, { method: 'post', body: JSON.stringify({ email, name }) });
  }
}
